// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import reject from 'lodash/reject'
import union from 'lodash/union'
import clone from 'lodash/clone'
import findIndex from 'lodash/findIndex'
import { arrayMove } from 'react-sortable-hoc'

// Constants
import { EMAIL } from 'constants/proposalCustomerFieldTypes'

// Atoms
import ItemsGrid from 'atoms/ItemsGrid'
import Spacer from 'atoms/Spacer'

// Components
import FieldLayout from '../FieldLayout'
import FieldAdd from './FieldAdd'
import Field from './Field'

export default class ProposalCustomerFields extends Component {
  static propTypes = {
    proposalFields: PropTypes.array.isRequired,
    customerFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
  }

  updateCustomerFields = (customerFields) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({
      data: { customerFields }
    })
  }

  handleFieldAdd = (field) => {
    const { customerFields } = this.props
    const nextCustomerFields = union(customerFields, [field])
    this.updateCustomerFields(nextCustomerFields)
  }

  handleFieldChange = field => (data) => {
    const { customerFields } = this.props
    const nextField = { ...field, ...data }
    const nextCustomerFields = clone(customerFields)
    const index = findIndex(nextCustomerFields, { key: field.key })
    nextCustomerFields[index] = nextField
    this.updateCustomerFields(nextCustomerFields)
  }

  handleFieldDelete = (field) => {
    if (field.type === EMAIL) {
      return undefined
    }
    return () => {
      const { customerFields } = this.props
      const nextCustomerFields = reject(customerFields, { key: field.key })
      this.updateCustomerFields(nextCustomerFields)
    }
  }

  handleSortEnd = ({ oldIndex, newIndex }) => {
    const { customerFields } = this.props
    const nextCustomerFields = arrayMove(customerFields, oldIndex, newIndex)
    this.updateCustomerFields(nextCustomerFields)
  }

  renderFields() {
    const { customerFields, proposalFields } = this.props
    return (
      <ItemsGrid spacing={16} onSortEnd={this.handleSortEnd}>
        { customerFields.map(field => (
          <Field
            key={field.key}
            field={field}
            onDelete={this.handleFieldDelete(field)}
          />
        )) }
        <FieldAdd
          disableSorting
          proposalFields={proposalFields}
          customerFields={customerFields}
          onAdd={this.handleFieldAdd}
        />
      </ItemsGrid>
    )
  }

  render() {
    return (
      <Fragment>
        <Spacer />
        <FieldLayout
          title="Customer info details"
          extraContent={this.renderFields()}
        />
      </Fragment>
    )
  }
}
